const HTTP_PROTOCOLS = new Set(["http:", "https:"])

export const AFAXYS_HOST_SUFFIXES = ["afaxys.com", "afaxyspharma.com", "econtra.com"] as const

function normalizeHostname(hostname: string) {
  return hostname.trim().toLowerCase()
}

function matchesHostnameSuffix(
  hostname: string,
  suffixes: readonly string[],
) {
  const normalizedHostname = normalizeHostname(hostname)

  return suffixes.some(suffix => {
    const normalizedSuffix = normalizeHostname(suffix)

    return (
      normalizedHostname === normalizedSuffix ||
      normalizedHostname.endsWith(`.${normalizedSuffix}`)
    )
  })
}

export function isHttpUrl(url: URL) {
  return HTTP_PROTOCOLS.has(url.protocol)
}

export function isExemptExternalHost(hostname: string) {
  return matchesHostnameSuffix(hostname, AFAXYS_HOST_SUFFIXES)
}
